import React from "react";
import { Col, Container, Row } from "react-bootstrap";

function ClientBrief() {
  return (
    <section className="client__brief p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={10} className="m-auto text-center">
            <h2 style={{ color: "#000" }}>
              Client <span style={{ color: "#F44336" }}>Brief</span>
            </h2>
            <p>
              Entertainment at its very best, Picture Pick is an exciting,
              picture-based guessing game app that you’re bound to get addicted
              to regardless of your age.
            </p>
            <h2 style={{ color: "#898989" }}>Mission</h2>
            <div className="mission_boxes">
              <div className="mission_box">
                YEAR - <span style={{ color: "#F44336" }}> 2019</span>
              </div>
              <div className="mission_box">
                ROLE - <span style={{ color: "#F44336" }}> UI/UX DESIGN</span>
              </div>
              <div className="mission_box">
                TYPE -
                <span style={{ color: "#F44336" }}> MOBILE APPLICATION</span>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default ClientBrief;
